import PropTypes from 'prop-types';
import React from 'react';
import { Icon, TextHtml } from 'ui';

const IconBackground = ({ icon, text, description, status, color = 'default' }) => {
  return (
    <div className={`icon-background icon-background--color-${color}`}>
      <div className="icon-background__icon">
        <Icon name={icon} color={color === 'first' ? 'primary' : color} />
      </div>
      {(text || description) && (
        <div className="icon-background__info">
          <span className="icon-background__info-text">
            <TextHtml text={text} />
          </span>
          <span className="icon-background__info-description">
            <TextHtml text={description} title={description} />
          </span>
          {status && <span className="icon-background__info-status">{status}</span>}
        </div>
      )}
    </div>
  );
};

IconBackground.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
  description: PropTypes.string,
  status: PropTypes.string,
  color: PropTypes.oneOf(['default', 'first', 'red']),
};

export default IconBackground;
